/**
 * Pickup limits for seasonal preorders. The bakery's open hours still apply.
 */

function dateOnly(value: string | null | undefined): string | null {
  const day = String(value || '').trim().split('T')[0];
  return /^\d{4}-\d{2}-\d{2}$/.test(day) ? day : null;
}

/** Earliest YYYY-MM-DD, or null when the list is empty. */
export function earliestYmd(values: Array<string | null | undefined>): string | null {
  const days = values.map(dateOnly).filter((day): day is string => Boolean(day));
  if (days.length === 0) return null;
  return days.sort()[0];
}

export function capPickupDates(dates: string[], through: string | null): string[] {
  const cap = dateOnly(through);
  if (!cap) return dates;
  return dates.filter((day) => day <= cap);
}

export function isOrderByClosed(orderBy: string | null | undefined, today: string): boolean {
  const by = dateOnly(orderBy);
  const now = dateOnly(today);
  if (!by || !now) return false;
  return now > by;
}
